/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */
import React from 'react'
import { getState, Status, ajax } from '../../twd'


const state = getState('municipals.green-bonds', {
    values: []
})

export default () => {
    const [values, setValues_] = React.useState(state.value.values || [])
    const setValues = React.useCallback((a) => {
        state.set({values:a})
        setValues_(a)
    }, [])

    const [status, setStatus] = React.useState(Status.LOADING)
    const [error, setError] = React.useState('')
    const lastAbort = React.useRef()

    React.useEffect(() => {

        ;(async () => {
            setValues({})
            setError('')
            setStatus(Status.LOADING)

            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                let {data, abort} = await ajax({
                    url: '/esb/retailservice/marketSnapshotService/getMarketSnapshotByType',
                    method: 'POST',
                    params: {
                        marketSnapshotsType: 'MUNI_GREEN_BOND_DATA'
                    }
                })

                lastAbort.current = abort
                let categories = await data
                lastAbort.current = null

                setValues(categories)
                setStatus(Status.LOADED)

            } catch (e) {
                setStatus(Status.FAILED_TO_LOAD)
            }

        })()


        return () => {
            if (lastAbort.current) {
                lastAbort.current()
            }
        }
    }, [])

    return {
        categories:values,
        error,
        status
    }
}
